// B2B logins no longer enforce the legacy per-account device allowance.
// Set to true and rebuild to restore the retained registration/limit policy.
export const DEVICE_LIMIT_ENFORCEMENT_ENABLED = false;

export function getDeviceRegistrationDecision(user, currentDevice, devices, enforceLimits = DEVICE_LIMIT_ENFORCEMENT_ENABLED) {
	const allow = { blocked: false, register: false };
	if (!enforceLimits || !currentDevice) {
		return allow;
	}
	if (devices.some(device => device.deviceId === currentDevice.deviceId)) {
		return allow;
	}
	if (!Object.prototype.hasOwnProperty.call(user, "subscriptionPlan")) {
		return { blocked: false, register: true };
	}

	const plan = user.subscriptionPlan || "";
	let limit = 0;
	if (plan === "basic-plan") {
		limit = 1;
	} else if (plan === "basic-plan-checkmate" || plan.startsWith("standard-plan")) {
		limit = 3;
	} else if (plan.startsWith("pro-plan")) {
		limit = Object.prototype.hasOwnProperty.call(user, "deviceLimit") ? user.deviceLimit : 5;
		if (limit === 0) {
			return allow;
		}
	}
	const hasCapacity = devices.length < limit;
	return { blocked: !hasCapacity, register: hasCapacity };
}

const DEVICE_REGISTRATION_ATTRIBUTES = [
	"custom:devices",
	"custom:deviceLimit",
	"custom:devicesBlacklist"
];

// ID-token claims can outlive a device removal or a change to the account limit.
// Missing/empty live attributes must also replace the older token values.
export function mergeLiveDeviceRegistrationAttributes(tokenAttributes = {}, liveAttributes = []) {
	const attributes = { ...tokenAttributes };
	DEVICE_REGISTRATION_ATTRIBUTES.forEach(name => delete attributes[name]);
	for (const { Name, Value } of liveAttributes) {
		if (DEVICE_REGISTRATION_ATTRIBUTES.includes(Name)) {
			attributes[Name] = Value;
		}
	}
	return attributes;
}

export function removeRegisteredDevice(devices, deviceId) {
	const index = devices.findIndex(device => device.deviceId === deviceId);
	// A stale row (including a repeated removal) must never remove another device.
	if (index === -1) {
		return null;
	}
	return devices.filter((device, position) => position !== index);
}

export async function removeDeviceRegistration(cognitoUser, deviceId, updateUserAttributes) {
	const attributes = await new Promise((resolve, reject) => {
		cognitoUser.getUserAttributes((err, result) => {
			if (err) {
				reject(err);
			} else {
				resolve(result);
			}
		});
	});
	const values = {};
	attributes.forEach(attribute => {
		values[attribute.getName()] = attribute.getValue();
	});
	const devices = JSON.parse(values["custom:devices"] || "[]");
	const remainingDevices = removeRegisteredDevice(devices, deviceId);
	if (remainingDevices === null) {
		return devices;
	}
	const blacklist = JSON.parse(values["custom:devicesBlacklist"] || "[]");
	// Save both attributes in one request and propagate failure before changing the UI.
	await updateUserAttributes(cognitoUser, {
		"custom:devices": JSON.stringify(remainingDevices),
		"custom:devicesBlacklist": JSON.stringify([...blacklist, deviceId])
	});
	return remainingDevices;
}
